/**------------- Used Car Drawer Carousel constants -------------**/

/*  General  */
export const USED_CAR_DRAWER_CAROUSEL_CONTAINER_CLASS_NAME =
	"carousel-container";

/*  Links  */
export const NO_USED_CAR_IMAGE_AVAILABLE_LINK =
	"/images/no-used-car-image-available.svg";
